module.exports = __webpack_public_path__ + "img/minesweeper.806aafb5.png";